module.exports = __webpack_public_path__ + "iconmonstr-twitter-1-48.png?3347dedad303166ca1806c7f2109c3e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconmonstr-twitter-1-48.png
// module id = 89
// module chunks = 0